import React, { CSSProperties, FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
  style?: CSSProperties;
}

export const ChevronLeftIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', style }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="m15.41 16.09-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6 1.41-1.41z" />
    </svg>
  );
};
